export const dedupeById = <T extends { id: number }>(arr: T[]) =>
	Array.from(new Map(arr.map((item) => [item.id, item])).values());
